import {gql} from "@irati/utils/gql"
import partialUser from "@irati/identity/services/fragments/PartialUser"

const fragment = gql`
  fragment CustomReward on CustomReward {
    uuid
    title
    locations
    policy
    redemptionInstructions
    status
    author {
      ...partialUser
    }
    regions {
      uuid
      teamState
      teamName
    }
  }
  ${partialUser}
`

export default fragment
